export default __webpack_public_path__ + "static/media/chevron_left_white.dcee89d6.svg";